const UI = {
  'add-user': 'if icon ui add-user',
  'arrow-back-top-left': 'if icon ui arrow-back-top-left',
  'arrow-down': 'if icon ui arrow-down',
  'arrow-left': 'if icon ui arrow-left',
  'arrow-right': 'if icon ui arrow-right',
  'arrow-up': 'if icon ui arrow-up',
  attach: 'if icon ui attach',
  'back-arrow': 'if icon ui back-arrow',
  'bank-card': 'if icon ui bank-card',
  books: 'if icon ui books',
  camera: 'if icon ui camera',
  chat: 'if icon ui chat',
  'check-circle': 'if icon ui check-circle',
  check: 'if icon ui check',
  cheque: 'if icon ui cheque',
  'chevron-down': 'if icon ui chevron-down',
  'chevron-left': 'if icon ui chevron-left',
  'chevron-right': 'if icon ui chevron-right',
  'chevron-up': 'if icon ui chevron-up',
  'chevrons-left': 'if icon ui chevrons-left',
  'chevrons-right': 'if icon ui chevrons-right',
  clock: 'if icon ui clock',
  close: 'if icon ui close',
  cockade: 'if icon ui cockade',
  cog: 'if icon ui cog',
  'computer-upload': 'if icon ui computer-upload',
  'corner-left-round': 'if icon ui corner-left-round',
  'data-download': 'if icon ui data-download',
  'data-upload': 'if icon ui data-upload',
  date: 'if icon ui date',
  'direct-edit': 'if icon ui direct-edit',
  dislike: 'if icon ui dislike',
  'document-docx': 'if icon ui document-docx',
  'document-pdf': 'if icon ui document-pdf',
  'document-pptx': 'if icon ui document-pptx',
  'document-xlsx': 'if icon ui document-xlsx',
  'drop-down': 'if icon ui drop-down',
  'drop-left': 'if icon ui drop-left',
  'drop-right': 'if icon ui drop-right',
  'drop-up': 'if icon ui drop-up',
  edit: 'if icon ui edit',
  'external-link': 'if icon ui external-link',
  'file-download': 'if icon ui file-download',
  film: 'if icon ui film',
  filter: 'if icon ui filter',
  fingerprint: 'if icon ui fingerprint',
  fullscreen: 'if icon ui fullscreen',
  handshake: 'if icon ui handshake',
  help: 'if icon ui help',
  hourglass: 'if icon ui hourglass',
  house: 'if icon ui house',
  img: 'if icon ui img',
  'incomming-call': 'if icon ui incomming-call',
  info: 'if icon ui info',
  invert: 'if icon ui invert',
  leave: 'if icon ui leave',
  like: 'if icon ui like',
  link: 'if icon ui link',
  list: 'if icon ui list',
  'lock-open': 'if icon ui lock-open',
  lock: 'if icon ui lock',
  'log-in': 'if icon ui log-in',
  'log-out': 'if icon ui log-out',
  mail: 'if icon ui mail',
  'map-pin': 'if icon ui map-pin',
  marker: 'if icon ui marker',
  math: 'if icon ui math',
  megaphone: 'if icon ui megaphone',
  menu: 'if icon ui menu',
  'microphone-off': 'if icon ui microphone-off',
  microphone: 'if icon ui microphone',
  microsoft: 'if icon ui microsoft',
  minus: 'if icon ui minus',
  'more-horizontal-filled': 'if icon ui more-horizontal-filled',
  'more-horizontal': 'if icon ui more-horizontal',
  'more-vertical': 'if icon ui more-vertical',
  multiple: 'if icon ui multiple',
  'open-in-new': 'if icon ui open-in-new',
  'outgoing-call': 'if icon ui outgoing-call',
  'pause-filled': 'if icon ui pause-filled',
  pause: 'if icon ui pause',
  pencil: 'if icon ui pencil',
  person: 'if icon ui person',
  'phone-call-end': 'if icon ui phone-call-end',
  phone: 'if icon ui phone',
  pin: 'if icon ui pin',
  'play-filled': 'if icon ui play-filled',
  play: 'if icon ui play',
  plus: 'if icon ui plus',
  'preview-off': 'if icon ui preview-off',
  preview: 'if icon ui preview',
  printer: 'if icon ui printer',
  'real-estate': 'if icon ui real-estate',
  recipe: 'if icon ui recipe',
  redo: 'if icon ui redo',
  refresh: 'if icon ui refresh',
  replace: 'if icon ui replace',
  resend: 'if icon ui resend',
  return: 'if icon ui return',
  search: 'if icon ui search',
  'secure-message': 'if icon ui secure-message',
  'send-message': 'if icon ui send-message',
  'setup-preferences': 'if icon ui setup-preferences',
  share: 'if icon ui share',
  'shopping-cart': 'if icon ui shopping-cart',
  signature: 'if icon ui signature',
  'single-folded': 'if icon ui single-folded',
  sound: 'if icon ui sound',
  'speech-bubble': 'if icon ui speech-bubble',
  stack: 'if icon ui stack',
  subtitles: 'if icon ui subtitles',
  tasks: 'if icon ui tasks',
  trashcan: 'if icon ui trashcan',
  'video-off': 'if icon ui video-off',
  'volume-mute': 'if icon ui volume-mute',
  volume: 'if icon ui volume',
  'warning-light': 'if icon ui warning-light',
  warning: 'if icon ui warning'
};

export default UI;
